module.exports = __webpack_public_path__ + "static/media/muji prototype.3fb470a6.gif";